import { render, staticRenderFns } from "./ClientesCanalPantalla.vue?vue&type=template&id=60f340ea&scoped=true&"
import script from "./ClientesCanalPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClientesCanalPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f340ea",
  null
  
)

export default component.exports